class Header {
   mainEl = document.querySelector('.header');
   #parentEl = this.mainEl.parentElement;

   constructor() {
      this.print();
   }

   print() {
      // console.log(this.#parentEl);
   }
}

const header = new Header();
// Put rootMargin: '-90px' when no more showing section-results
const options = { root: null, threshold: 0 };

const turnNavbarWhite = function (entries, observer) {
   const [entry] = entries;
   const { isIntersecting } = entry;

   header.mainEl
      .querySelector('.nav')
      .classList[`${isIntersecting ? 'remove' : 'add'}`]('nav--white');
};

const headerObserver = new IntersectionObserver(turnNavbarWhite, options);
headerObserver.observe(header.mainEl);
